// Imports
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import APIButton, { APIButtonOptions } from '../../../../../../shareables/integrations/api/components/button';
import { GetRecipesResponse } from '../../../../../../shareables/types/api/main/website/page/type/213/recipes/get';
import Byline from '../shared-components/byline';
import getHumanReadableTime from './utils/get-human-readable-time';
import { Link } from 'react-router-dom';


// Define the accepted props
interface Props {
	recipe: GetRecipesResponse[0];
	onChange: () => void;
	pageID: number;
	displayRemoveCell: boolean;
}


// Function component
const RecipesRow: React.FC<Props> = ({ recipe, onChange, pageID, displayRemoveCell }) => {
	// Build button options
	const buttonOptions: APIButtonOptions<undefined, undefined, undefined> = {
		action: 'DELETE',
		uri: `/website/${window.location.hostname}/page/id_${pageID}/type/213/recipe/${recipe.id}`,
		tooltip: 'Delete this recipe',
		warning: {
			message: 'Deleting this recipe is permanent.',
			button: `Yes, delete “${recipe.name}”`,
		},
	};
	
	
	// Return JSX
	return (
		<tr>
			<td className='allow-wrapping'>
				<Link to={`recipe/${recipe.id}`}>{recipe.name}</Link>
				<Byline className='is-gray' post={recipe} created={recipe.submitted} action='submitted' />
			</td>
			
			<td>{getHumanReadableTime(recipe.time, true)}</td>
			
			{displayRemoveCell && (
				<td style={{ textAlign: 'center' }}>
					{recipe.canDelete && (
						<APIButton
							options={buttonOptions}
							color='danger'
							aria-label={`Delete “${recipe.name}”`}
							onCompletion={onChange}
							smaller
						>
							<FontAwesomeIcon icon={faTrash} />
						</APIButton>
					)}
				</td>
			)}
		</tr>
	);
};

export default RecipesRow;
